const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};

const baseUrl = process.env.REACT_APP_API_HOST
  ? process.env.REACT_APP_API_HOST
  : 'http://localhost:2999';

export const requestCheckJWT = async token => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/user/checkJWT`, {
    method: 'post',
    headers
  });
  const { status } = response;
  const { error, user, data } = await response.json();
  return { status, error, user, data };
};

export const requestUserUpdate = async (token, name, phone) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/user/update/profile`, {
    method: 'post',
    headers,
    body: JSON.stringify({
      name,
      phone
    })
  });
  const { status } = response;
  const { error } = await response.json();
  return { status, error };
};

export const requestPasswordChange = async (token, password) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/user/update/password`, {
    method: 'post',
    headers,
    body: JSON.stringify({
      password
    })
  });
  const { status } = response;
  const { error } = await response.json();
  return { status, error };
};

export const requestGames = async (
  token,
  numRows = 10,
  lastStartDate = null,
  lastGameId = null,
  startDate,
  limitByDate
) => {
  headers['Authorization'] = token;
  const response = await fetch(
    `${baseUrl}/api/games?numRows=${numRows}&startDate=${startDate}&limitByDate=${limitByDate}&lastStartDate=${lastStartDate}&lastGameId=${lastGameId}`,
    {
      method: 'get',
      headers
    }
  );
  const { status } = response;
  const { error, gamesList, games } = await response.json();
  return { status, error, gamesList, games };
};

export const requestUmpInfo = async (token, memberId) => {
  headers['Authorization'] = token;
  const urlString = memberId ? `${baseUrl}/api/umpire/info/${memberId}` : `${baseUrl}/api/umpire/selectList`;
  const response = await fetch(urlString, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, umpires, umpiresList } = await response.json();
  return { status, error, umpires, umpiresList };
};

export const requestUmpSelectList = async token => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/umpire/selectList`, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, umpires, umpiresList } = await response.json();
  return { status, error, umpires, umpiresList };
};

export const requestOrganizations = async token => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/organizations`, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, organizationsList, organizations } = await response.json();
  return { status, error, organizationsList, organizations };
};

//API for Seasons

export const requestSeasons = async token => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/seasons`, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, seasonsList, seasons } = await response.json();
  return { status, error, seasonsList, seasons };
};

export const requestAllSeasons = async token => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/seasons`, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, seasonsList, seasons } = await response.json();
  return { status, error, seasonsList, seasons };
};

export const requestSeasonsByActive = async (token, activeSeason) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/seasons/${activeSeason}`, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, seasonsList, seasons } = await response.json();
  return { status, error, seasonsList, seasons };
};

export const requestSeasonsByDisplay = async (token, displaySeason) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/seasons/display/${displaySeason}`, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, seasonsList, seasons } = await response.json();
  return { status, error, seasonsList, seasons };
};

export const requestSeasonDivisions = async (token, seasonId) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/seasons/${seasonId}/divisions`, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, divisions, divisionsList } = await response.json();
  return { status, error, divisions, divisionsList };
};

export const requestUpdateSeasonMaxDate = async (token, seasonId, maxDate) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/seasons/${seasonId}/maxDate`, {
    method: 'put',
    headers,
    body: JSON.stringify({
      maxDate
    })
  });
  const { status } = response;
  const { error, newMaxDate } = await response.json();
  return { status, error, newMaxDate };
};

//API for Divisions

export const requestDivisions = async token => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/divisions`, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, divisions, divisionsList, parentDivisionsList } = await response.json();
  return { status, error, divisions, divisionsList, parentDivisionsList };
};

export const requestTeams = async (token, seasonId, divisionId) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/teams?seasonId=${seasonId}&divisionId=${divisionId}`, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, teams, teamsList } = await response.json();
  return { status, error, teams, teamsList };
};

export const requestAddCoachToTeam = async (token, teamId, seasonId) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/coach/addTeam`, {
    method: 'post',
    headers,
    body: JSON.stringify({ seasonId, teamId })
  });
  const { status } = response;
  const { error } = await response.json();
  return { status, error };
};

export const requestRemoveCoachFromTeam = async (token, memberId, teamId, seasonId) => {
  headers['Authorization'] = token;
    const response = await fetch(`${baseUrl}/api/coach/removeTeam`, {
    method: 'post',
    headers,
    body: JSON.stringify({ memberId, teamId, seasonId })
  });
  const { status } = response;
  const { error } = await response.json();
  return { memberId, teamId, seasonId, status, error };
};

export const requestAssignUmpToGame = async (token, umpireId, gameId, plate) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/umpire/add`, {
    method: 'post',
    headers,
    body: JSON.stringify({ umpireId, gameId, plate })
  });
  const { status } = response;
  const { error, updatedGame } = await response.json();
  return { status, error, updatedGame };
};

export const requestRemoveUmpFromGame = async (token, umpireId, gameId, plate) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/umpire/remove`, {
    method: 'post',
    headers,
    body: JSON.stringify({ umpireId, gameId, plate })
  });
  const { status } = response;
  const { error, updatedGame } = await response.json();
  return { status, error, updatedGame };
};

export const requestMyGames = async (token, season, team, umpire, startDate) => {
  headers['Authorization'] = token;
  const response = await fetch(
    `${baseUrl}/api/games/myGames?season=${season}&team=${team}&umpire=${umpire}&startDate=${startDate}`,
    {
      method: 'get',
      headers
    }
  );
  const { status } = response;
  const { error, myGamesList, games } = await response.json();
  return { status, myGamesList, games, error };
};

export const requestFilteredGames = async (token, startDate, endDate, season, division, team, umpire, showAllGames, limitResults) => {
  headers['Authorization'] = token;
  const response = await fetch(
    `${baseUrl}/api/games/filter?startDate=${startDate}&endDate=${endDate}&season=${season}&division=${division}&team=${team}&umpire=${umpire}&showAllGames=${showAllGames}&limitResults=${limitResults}`,
    {
      method: 'get',
      headers
    }
  );
  const { status } = response;
  const { error, filteredGamesList, games } = await response.json();
  return { status, filteredGamesList, games, error };
};

export const requestCoachesList = async (token, seasonId) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/coach/list?seasonId=${seasonId}`, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, coachesList } = await response.json();
  return { status, error, coachesList };
};

export const requestDailySummary = async (token, summaryDay) => {
  headers['Authorization'] = token;
  const urlString = summaryDay ? `${baseUrl}/api/games/dailySummary/${summaryDay}` : `${baseUrl}/api/games/dailySummary`;
  const response = await fetch(urlString, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, dailySummary } = await response.json();
  return { status, error, dailySummary };
};

export const requestUmpiresList = async (token, seasonId = null) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/umpire/list?seasonId=${seasonId}`, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, umpiresList, umpires } = await response.json();
  return { status, error, umpiresList, umpires };
};

export const requestUmpireUpdate = async (token, memberId, umpireLevel, plateUmpire, baseUmpire, isMentor, isActive, isYouth, seasonId) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/umpire/update`, {
    method: 'post',
    headers,
    body: JSON.stringify({
      memberId,
      umpireLevel,
      plateUmpire,
      baseUmpire,
      isMentor,
      isActive,
      isYouth,
      seasonId
    })
  });
  const { status } = response;
  const res = await response.json();
  return { status, error: res.error, updatedUmp: res };
};

export const requestPlayersList = async (token, seasonId) => {
  headers['Authorization'] = token;
  const urlString = seasonId === null ? `${baseUrl}/api/player` : `${baseUrl}/api/player/filter/${seasonId}`;
  const response = await fetch(urlString, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, playersList } = await response.json();
  return { status, error, playersList };
};

export const requestMembersList = async token => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/member`, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, membersList, members } = await response.json();
  return { status, error, membersList, members };
};

export const requestMentorsList = async (token, seasonId) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/umpire/mentor/list?seasonId=${seasonId}`, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, mentorsList } = await response.json();
  return { status, error, mentorsList };
};

export const requestMenteeUpdate = async (token, mentorId, menteeId, column, seasonId, operation) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/umpire/mentees/update`, {
    method: 'post',
    headers,
    body: JSON.stringify({
      mentorId,
      menteeId,
      column,
      seasonId,
      operation
    })
  });
  const { status } = response;
  const { error, updatedMentees } = await response.json();
  return { status, error, updatedMentees };
};

export const requestMentorMenteeInfo = async (token, memberId, seasonId) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/umpire/isMentorMentee/${memberId}/${seasonId}`, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, mentorMenteeInfo } = await response.json();
  return { status, error, mentorMenteeInfo };
};

export const requestUmpiresNextGame = async (token, memberId) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/umpire/nextGame/${memberId}`, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, nextGame } = await response.json();
  return { status, error, nextGame };
};

export const requestCoachesTeams = async (token, memberId, seasonId = null) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/coach/teams/${memberId}/${seasonId}`, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, teamsList } = await response.json();
  return { status, error, teamsList };
};

export const requestTeamsVolunteering = async (token, memberId, seasonId = null) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/teams/volunteer/${memberId}/${seasonId}`, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, teamsList } = await response.json();
  return { status, error, teamsList };
};

export const requestTeamVolunteerUpdate = async (token, memberId, seasonId, teamId, column, value, operation) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/teams/volunteer/update`, {
    method: 'post',
    headers,
    body: JSON.stringify({
      memberId,
      seasonId,
      teamId,
      column,
      value,
      operation
    })
  });
  const { status } = response;
  const { error, teamsList } = await response.json();
  return { status, error, teamsList };
};

export const requestUpdateUserRole = async (token, memberId, email, isAdmin) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/user/update/role`, {
    method: 'post',
    headers,
    body: JSON.stringify({
      memberId,
      email,
      isAdmin
    })
  });
  const { status } = response;
  const { error, user } = await response.json();
  return { status, error, user };
};

export const requestUpdateUserInfo = async (token, memberId, email, firstName, lastName, cellPhone) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/user/update/userinfo`, {
    method: 'post',
    headers,
    body: JSON.stringify({
      memberId,
      email,
      firstName,
      lastName,
      cellPhone
    })
  });
  const responseData = await response.json(); // Wait for the JSON data to be resolved
  const { status } = response;
  const { error, user } = responseData;
  return { status, error, user };
};

export const requestSeasonUmpireData = async (token, seasonId) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/reports/seasons/${seasonId}/umpires`, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, umpires, umpiresList } = await response.json();
  return { status, error, umpires, umpiresList };
};

export const requestYtdDataSummary = async token => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/reports/ytdSummaryData`, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, seasons, seasonsList } = await response.json();
  return { status, error, seasons, seasonsList };
};

//Reports and Statistics APIs

export const requestWheelData = async (token, seasonId) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/reports/seasons/${seasonId}/wheel`, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, wheelUmpires, wheelUmpiresList } = await response.json();
  return { status, error, wheelUmpires, wheelUmpiresList };
};

export const requestFullSeasonStats = async (token, parentSeasonId) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/reports/seasons/${parentSeasonId}/fullStats`, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, seasons, seasonsList, umpires, umpiresList } = await response.json();
  return { status, error, seasons, seasonsList, umpires, umpiresList };
};

export const requestUmpireStats = async (token, seasonId, memberId) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/reports/seasons/${seasonId}/umpireStats/${memberId}`, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, umpireStats } = await response.json();
  return { status, error, umpireStats };
};

export const requestTeamVolunteerData = async (token, seasonId) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/reports/seasons/${seasonId}/teamVolunteers`, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, teams, teamsList } = await response.json();
  return { status, error, teams, teamsList };
};

export const requestUpdateUmpAvailableForGame = async (token, gameID, umpireAvailable) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/games/umpAvailable`, {
    method: 'post',
    headers,
    body: JSON.stringify({ gameId: gameID, umpAvailable: umpireAvailable })
  });
  const { status } = response;
  const { error, gameId, umpAvailable } = await response.json();
  return { status, error, gameId, umpAvailable };
};

//End Report APIs

export const requestTodaysWeather = async (token, latitude, longitude, timezone) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/weather/today/?latitude=${latitude}&longitude=${longitude}&timezone=${timezone}`, {
    method: 'get',
    headers
  });
  const { status } = response;
  const { error, todaysWeather } = await response.json();
  return { error, status, todaysWeather };
}

export const requestSendMessage = async (token, message, recipients) => {
  const headers = {
    'Authorization': token,
    'Content-Type': 'application/json'
  };
  console.log(JSON.stringify({
      message,
      recipients
    }));
  const response = await fetch(`${baseUrl}/api/sms/sendMessage`, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      message,
      recipients
    })
  });
  const { status } = response;
  const { error, responseMessage } = await response.text()
  return { error, status, responseMessage };
}

export const requestUpdateSeasonActive = async (token, seasonId, active) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/seasons/${seasonId}/active`, {
    method: 'put',
    headers,
    body: JSON.stringify({
      active
    })
  });
  const { status } = response;
  const { error, newActive } = await response.json();
  return { status, error, newActive };
};


export const requestUpdateSeasonDisplay = async (token, seasonId, display) => {
  headers['Authorization'] = token;
  const response = await fetch(`${baseUrl}/api/seasons/${seasonId}/display`, {
    method: 'put',
    headers,
    body: JSON.stringify({
      display
    })
  });
  const { status } = response;
  const { error, newDisplay } = await response.json();
  return { status, error, newDisplay };
};



// WEBPACK FOOTER //
// ./src/actions/api.js